const KEYS = { settings: "impostor.ajustes", words: "impostor.palabras", used: "impostor.usados", board: "impostor.marcador" };

export const POINTS = { inocente: 1, impostor: 2 };
const NIGHT_MS = 12 * 60 * 60 * 1000;
export const emptyBoard = () => ({ scores: {}, games: 0, updated: Date.now() });

export function loadBoard() {
  const b = load("board", null);
  return b && Date.now() - b.updated < NIGHT_MS ? b : emptyBoard();
}

export function scoreGame(board, players, w) {
  const role = w === "inocentes" ? "inocente" : "impostor";
  const delta = Object.fromEntries(players.map((p) => [p.name, p.role === role ? POINTS[role] : 0]));
  const scores = { ...board.scores };
  for (const p of players) scores[p.name] = (scores[p.name] || 0) + delta[p.name];
  return { board: { scores, games: board.games + 1, updated: Date.now() }, delta };
}

export const load = (k, def) => {
  try {
    const v = localStorage.getItem(KEYS[k]);
    return v ? JSON.parse(v) : def;
  } catch {
    return def;
  }
};
export const save = (k, v) => localStorage.setItem(KEYS[k], JSON.stringify(v));
export const remove = (k) => localStorage.removeItem(KEYS[k]);

export const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};
export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const str = (s) => typeof s === "string" && s.trim().length > 0;

export function validateWords(d) {
  if (!d || typeof d !== "object" || Array.isArray(d)) return "El contenido no es un objeto JSON.";
  if (typeof d.version !== "number") return 'Falta el campo "version" (número).';
  if (!Array.isArray(d.categorias) || !d.categorias.length) return 'Falta la lista "categorias".';
  for (const c of d.categorias) {
    if (!c || !str(c.nombre)) return 'Hay una categoría sin "nombre".';
    if (!Array.isArray(c.pares) || !c.pares.length) return `La categoría "${c.nombre}" no tiene pares.`;
    for (const p of c.pares) {
      if (!p || !str(p.normal) || !str(p.impostor)) return `Hay un par inválido en "${c.nombre}".`;
    }
  }
  return null;
}

export function pickPair(data, cats, used) {
  const all = data.categorias
    .filter((c) => cats.includes(c.nombre))
    .flatMap((c) => c.pares.map((p) => ({ categoria: c.nombre, normal: p.normal, impostor: p.impostor, key: `${c.nombre}|${p.normal}|${p.impostor}` })));
  const fresh = all.filter((p) => !used.includes(p.key));
  return { pair: pick(fresh.length ? fresh : all), reset: !fresh.length };
}

export function deal(names, nImp, pair, mode) {
  const imps = shuffle(names.map((_, i) => i)).slice(0, nImp);
  return names.map((name, i) => {
    const imp = imps.includes(i);
    return { name, role: imp ? "impostor" : "inocente", word: imp ? (mode === "parecida" ? pair.impostor : null) : pair.normal, alive: true };
  });
}

export function winner(players) {
  const alive = players.filter((p) => p.alive);
  const imp = alive.filter((p) => p.role === "impostor").length;
  if (imp === 0) return "inocentes";
  if (alive.length === imp) return "impostores";
  return null;
}

export function turnOrder(players, starter) {
  const alive = players.filter((p) => p.alive).map((p) => p.name);
  const i = Math.max(0, alive.indexOf(starter));
  return [...alive.slice(i), ...alive.slice(0, i)];
}
